import { render, staticRenderFns } from "./PlatformPaymentForm.vue?vue&type=template&id=a4227352&scoped=true"
import script from "./PlatformPaymentForm.vue?vue&type=script&lang=js"
export * from "./PlatformPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./PlatformPaymentForm.vue?vue&type=style&index=0&id=a4227352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4227352",
  null
  
)

export default component.exports